import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";

import * as FaIcons from "react-icons/fa";

import { Helmet } from "react-helmet-async";

import InterestFormList from "../../components/interestAdmin/InterestFormList";
import LoadingSpinner from "../../components/utilities/LoadingSpinner";
import llacFav from "../../img/LLAC-favicon.ico";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";

const InterestFormListPage = () => {
  const navigate = useNavigate();
  const adminInterestContext = useContext(AdminInterestContext);
  const {
    getEntries,
    entries,
    gettransferRegistrations,
    clearAgeFilter,
    clearSearchFilter,
    clearTableFilter,
    loading,
    clearNotinterestFilter,
    clearTransfer,
  } = adminInterestContext;

  
  useEffect(() => {
    getEntries();
    gettransferRegistrations();
    return () => {
      clearAgeFilter();
      clearSearchFilter();
      clearTableFilter();
      clearNotinterestFilter();
      clearTransfer();
    };
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Interest Dashboard</title>
        <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      <section id="interest-form-list-page">
        <div className="container">
          {/* <h2 className="text-center top-title">Interest Forms</h2> */}
          {/* {entries.length > 0 ? ( */}
            <InterestFormList items={entries} />
          {/* ) : !loading ? (
            <div className="interest-complete">
              <FaIcons.FaCheckSquare className="done-icon" />
              <p>Looks like were out of Interest forms</p>
              <p>Good Job!</p>
            </div>
          ) : (
            <LoadingSpinner />
          )} */}
        </div>
      </section>
    </AdminLayout>
  );
};

export default InterestFormListPage;
